import { API, API_ORIGIN } from "../utils";

export const createOrg = async ({ body }) => {
  const response = await API.post("/organization", body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

/* Closes the setup wizard for the current organization. Until this succeeds the
 * panel stays behind the wizard — see Routes.js. */
export const completeOnboarding = async () => {
  const response = await API.post("/organization/onboarding-complete");
  return response.data;
};

export const getOrganization = async () => {
  const response = await API.get("/organization");
  return response.data;
};

export const loginOtp = async ({ body }) => {
  const response = API.post("/auth/login-otp", body);
  const data = await response;
  return data;
};

export const checkOtp = async ({ body }) => {
  const response = API.post("/auth/check-otp", body);
  const data = await response;
  return data;
};

/* صفحه‌ای که گوگل کاربر را — از راه سرویس — به آن برمی‌گرداند. همین رشته در
 * `GOOGLE_ALLOWED_TARGETS` سرویس هم هست؛ هر مقصد دیگری آنجا رد می‌شود. */
export const GOOGLE_CALLBACK_PATH = "/google-callback";

/* شروع «ورود با گوگل». پنل مستقیم با گوگل حرف نمی‌زند: `redirect_uri` ثبت‌شده
 * در کنسول گوگل آدرس سرویس است، پس رفت‌وبرگشت از آنجا رد می‌شود و سرویس در
 * پایان کاربر را با یک access_token کوتاه‌عمر به این صفحه برمی‌گرداند. */
export const googleLoginUrl = () =>
  `${API_ORIGIN}/oauth/redirect?target_url=${encodeURIComponent(
    `${window.location.origin}${GOOGLE_CALLBACK_PATH}`,
  )}`;

export const loginGoogle = async ({ body }) => {
  const response = API.post("/auth/login-google", body);
  const data = await response;
  return data;
};

export const logoutUser = async () => {
  const response = API.put("/auth/logout");
  const data = await response;
  return data;
};

export const updateOrganization = async ({ body }) => {
  const response = API.patch("/organization", body, {});
  const data = await response;
  return data;
};

export const patchProfile = async ({ body, headers }) => {
  const response = API.patch("/auth/profile", body, { headers });
  const data = await response;
  return data;
};

export const getProfile = async () => {
  const response = API.get("/auth/profile");
  const data = await response;
  return data;
};

export const getNotifications = async ({ params } = {}) => {
  const response = API.get("/auth/notifications", { params });
  const data = await response;
  return data;
};

export const readNotification = async ({ params }) => {
  const response = API.put(`/auth/notifications/${params.id}/read`);
  const data = await response;
  return data;
};

export const readAllNotification = async ({ params }) => {
  const response = API.put(`/auth/notifications/read-all`);
  const data = await response;
  return data;
};
